module.exports = __webpack_public_path__ + "img/big_1_28.5b8c5ae5.png";